import React from 'react'
import styles from './Header.module.sass'
import {Burger} from "../LeftBar/LeftBar";


export function Header() {
    return (
        <header className={styles.header}>
            <div className={styles.row}>
                {/*<Burger />*/}
                <span className={styles.logo_txt}>
                    <a href="/">CNR</a>
                </span>
                <img className={styles.logo} src="/images/cnr-logo.jpg" alt=""/>
                <span className={styles.desc}>Staking Dashboard</span>
            </div>
            {/*<button className={styles.button}>
                <img src="/images/cnr-logo.jpg" style={{ width: 30, height: 30 }} alt=""/>
                <span>Get CNR</span>
            </button>*/}
        </header>
    )
}
